<template>
  <div class="question-input-number is-flex-col gap-1 pb-3">
    <div
      v-for="item of itemsWithConfig"
      :key="item.text"
      class="is-flex align-center gap-1-4"
    >
      <b-field
        class="m-0 "
        style="width: 10em; text-align: right"
      >
        <b-numberinput
          v-model="answer[item.text]"
          controls-alignment="left"
          controls-position="compact"
          icon-pack="fa"
          exponential
          :min="item.min"
          :max="item.max"
          :step="item.step"
          :min-step="item.minStep"
          @input="$emit('answered', answer)"
        />
      </b-field>

      <label>{{ item.suffix }}<span class="bold ml-1">{{ item.text }}</span></label>
    </div>
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'


export default {
  name: 'ComponentName',
  components: { /* Subcomponents */ },
  props: ['items', 'config', 'prevAnswer'],
  data() {
    return {
      defaults: {
        min: 0,
        max: 100,
        step: 1,
        minStep: 1,
      },
      answer: this.prevAnswer ? { ...this.prevAnswer } : {},
    };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    formatted() {
      return this.items.map(i => {
        if (typeof i !== 'string') return i;
        return { text: i };
      });
    },
    itemsWithConfig() {
      return this.formatted.map(item => {
        const i = { ...item, types: {} };

        for (const field of ['min', 'max', 'step', 'minStep', 'suffix']) {
          if (typeof i[field] === 'number') continue;
          const config = this.config ? this.config[field] : null;
          i[field] = config ? config : this.defaults[field];
        }
        return i;
      });
    },
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {},
};
</script>


<style scoped>

</style>
